import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators';

@Module({ name: 'shopModule', namespaced: true })
export default class ShopModule extends VuexModule {

    shop: Shop|null = null;
    errors: object = {};

    get getShop(): Shop|null {
        return this.shop;
    }

    get getErrors(): object {
        return this.errors;
    }

    @Action
    getImageSrc(src: string | null): string|File {
        return src ?? (this.shop?.product_image ?? '');
    }

    @Action({ commit: 'SET_SHOP' })
    setShop(shop: Shop): Shop {
        return shop;
    }

    @Action({ commit: 'SET_ERRORS' })
    setErrors(errors: object): object {
        return errors;
    }

    @Mutation
    SET_SHOP(shop: Shop) {
        this.shop = shop;
    }

    @Mutation
    SET_ERRORS(errors: object): void {
        this.errors = errors;
    }

}
